<template>
    <svg :class="className" width="14" height="9" viewBox="0 0 14 9">
        <path d="M2.8219 5.21674L4.97842 7.21239C5.3219 7.55239 5.3219 8.10196 4.97842 8.44196C4.63408 8.78196 4.07668
            8.78196 3.73321 8.44196L0.38625 5.27065C0.137554 5.0237 0.000163078 4.69761 0.000163078 4.34804C0.000163078
            3.99935 0.137554 3.67152 0.38625 3.4263L3.73321 0.255C4.07668 -0.085 4.63408 -0.085 4.97842 0.255C5.3219
            0.59413 5.3219 1.14457 4.97842 1.48457L2.82364 3.47761H13.0367C13.5167 3.47761 13.9062 3.86717 13.9062
            4.34717C13.9062 4.82717 13.5167 5.21674 13.0367 5.21674H2.8219Z">
        </path>
    </svg>
</template>

<script>
export default {props: ['className']};
</script>
